import React, { useEffect, useRef } from 'react';
import useAxios from 'axios-hooks';
import useMessages from '../../../hooks/useMessages';
import Form from './Form';
import AnswersBlock from './AnswersBlock';
import WitMessage from './WitMessage';
import axios from "axios";
import useNavigation from "../../../hooks/useNavigation";


const thinkingMessage = {
  bot: true,
  isThinking: true,
  answers: [{
    followUpAction: 'ANSWER',
    translations: [
      {
        language: 'EN',
        text: '...'
      }
    ]
  }],
  type: "MESSAGE"
};

const MessageList = () => {
  // we render the options and add them to the array

  const { messages, addMessage, showForm, addEndOfConversationMessage, isThinking } = useMessages();
  const { initialMessage } = useNavigation();

  const bottomList = useRef(undefined);


  useEffect( () => {
    const pushInitialMessage = async () => {
      await addMessage({
        bot: false,
        answers: [{
          ...initialMessage,
          followUpAction: 'ANSWER',
        }]
      });

      if(initialMessage?.followUpAction === "INTENT"){
        const { data } = await axios.get(`/intent/${initialMessage.followUpIntentId}`);
        if (data?.intent?.answers?.length) {
          const message = {
            bot: true,
            intent: data.intent,
            answers: data.intent.answers
          };

          await addMessage(message);
        }
      }
      else if(initialMessage?.followUpAction === "FORM"){
        await addMessage({
          bot: true,
          answers: [initialMessage]
        });

        await showForm();
      }
    }
    pushInitialMessage().catch((error) => console.error(error));
  }, [initialMessage]);


  useEffect(() => {
    if (messages.length > 1) {
      if (bottomList.current) {
        bottomList.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [messages, isThinking]);

  const renderMessages = () => {
    let i = 0;
    return messages.map((message) => {
      i++;

      // console.log('rendering', message)

      if (message.wit) {
        return (<WitMessage key={i} message={message} />);
      }

      if (message.type === 'MESSAGE') {
        return (<AnswersBlock key={i} message={message} />);
      }

      return <Form key={i} />;
    });
  };


  return (
    <>
      <div className="message-list">
        {renderMessages()}
        {isThinking && <AnswersBlock message={thinkingMessage} /> }
        <div id="message-list-ref" ref={bottomList}>&nbsp;</div>
      </div>
    </>
  );
};

export default MessageList;
